<div class="flex flex-col gap-4 rounded-md bg-white p-4 shadow-md">
  <h3 class="!m-0 !font-bold">Patient Recalls</h3>

  @for (track of enabledTracks(); track track) {
    @let recall = getRecall(track);

    @if ($index > 0) {
      <mat-divider />
    }

    <div class="flex flex-col gap-4">
      <div class="flex flex-row items-center gap-2">
        <h4 class="!m-0 flex grow !font-semibold">{{ trackLabel(track) }}</h4>
        <pr-icon-chip
          icon="check_circle"
          [iconClass]="recall?.isDisabled ? 'text-slate-500' : 'text-green-500'"
        >
          {{ recall?.isDisabled ? 'Disabled' : 'Enabled' }}
        </pr-icon-chip>
        <button
          mat-icon-button
          class="icon-sm"
          (click)="recalls.editPatientRecallSettings(patient(), track)"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </div>

      @if (!recall?.isDisabled) {
        <div class="flex flex-row items-start gap-4">
          <div class="flex w-1/2 flex-col">
            <div class="font-bold">Recall Period</div>
            @if (recall?.periodInMonths; as periodInMonths) {
              <div>{{ periodInMonths }} months</div>
            } @else {
              @if (getDefaultPeriodInMonths(track); as defaultPeriod) {
                <div class="opacity-50">{{ defaultPeriod }} months</div>
              } @else {
                <div class="text-xs opacity-50">Not Set</div>
              }
            }
          </div>

          <div class="flex w-1/2 flex-col">
            <div class="font-bold">Next Recall Due</div>
            @if (recall?.nextRecallDue?.isSet) {
              <div>
                {{
                  recall?.nextRecallDue?.dueAt
                    | moment
                    | amDateFormat: dateFormat
                }}
              </div>
              <div class="text-xs opacity-50">
                {{ getRecallDueDistance(track) }}
              </div>
            } @else {
              <div class="text-xs opacity-50">Not Set</div>
            }
          </div>
        </div>

        @if (recall) {
          <div class="flex flex-row items-start gap-4">
            <pr-recall-appointment
              class="flex w-1/2"
              label="Last Recall"
              [appointmentRef]="recall.lastRecallAppointment"
              [recallDate]="recall.lastCompletedAt"
            />
            <pr-recall-appointment
              class="flex w-1/2"
              label="Next Recall"
              emptyMessage="Not Booked"
              [appointmentRef]="recall.nextRecallAppointment"
            />
          </div>
        }
      }
    </div>
  }
</div>
